var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("btn btn-default btn-" + _vm.size),on:{"click":function($event){_vm.hasHistory() ? _vm.$router.go(-1) : _vm.$router.push('/')}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t("button.back"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }